import { render, staticRenderFns } from "./DsTournamentEfectivities.vue?vue&type=template&id=65d89bbe&scoped=true"
import script from "./DsTournamentEfectivities.vue?vue&type=script&lang=js"
export * from "./DsTournamentEfectivities.vue?vue&type=script&lang=js"
import style0 from "./DsTournamentEfectivities.vue?vue&type=style&index=0&id=65d89bbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d89bbe",
  null
  
)

export default component.exports